import i from "./index443.mjs";
import b from "./index444.mjs";
import l from "./index445.mjs";
import { createUnaryUnit as u, getValue as c } from "./index446.mjs";
import { handleBreakpoints as m } from "./index447.mjs";
function e(r) {
  return typeof r != "number" ? r : `${r}px solid`;
}
function o(r, t) {
  return b({
    prop: r,
    themeKey: "borders",
    transform: t
  });
}
const f = o("border", e), a = o("borderTop", e), p = o("borderRight", e), R = o("borderBottom", e), C = o("borderLeft", e), h = o("borderColor"), y = o("borderTopColor"), T = o("borderRightColor"), B = o("borderBottomColor"), g = o("borderLeftColor"), L = o("outline", e), P = o("outlineColor"), d = (r) => {
  if (r.borderRadius !== void 0 && r.borderRadius !== null) {
    const t = u(r.theme, "shape.borderRadius", 4, "borderRadius"), n = (s) => ({
      borderRadius: c(t, s)
    });
    return m(r, r.borderRadius, n);
  }
  return null;
};
d.propTypes = process.env.NODE_ENV !== "production" ? {
  borderRadius: i
} : {};
d.filterProps = ["borderRadius"];
l(f, a, p, R, C, h, y, T, B, g, d, L, P);
export {
  f as border,
  R as borderBottom,
  B as borderBottomColor,
  h as borderColor,
  C as borderLeft,
  g as borderLeftColor,
  d as borderRadius,
  p as borderRight,
  T as borderRightColor,
  a as borderTop,
  y as borderTopColor,
  e as borderTransform,
  L as outline,
  P as outlineColor
};
